import { render, staticRenderFns } from "./WBonos.vue?vue&type=template&id=e06d4666&scoped=true&"
import script from "./WBonos.vue?vue&type=script&lang=js&"
export * from "./WBonos.vue?vue&type=script&lang=js&"
import style0 from "./WBonos.vue?vue&type=style&index=0&id=e06d4666&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06d4666",
  null
  
)

export default component.exports